import { getSettingRetailerExclusivityAgreements } from "@faire/help-center-utils/settings/getSettingRetailerExclusivityAgreements";
export var HowDoesSignupWorkIA = function HowDoesSignupWorkIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return HOW_DOES_SIGNUP_OFFER_WORK_TITLE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [HOW_DOES_SIGNUP_OFFER_WORK_DESCRIPTION(strictLocalize)];
    }
  };
};
var HOW_DOES_SIGNUP_OFFER_WORK_TITLE = function HOW_DOES_SIGNUP_OFFER_WORK_TITLE(strictLocalize) {
  if (getSettingRetailerExclusivityAgreements()) {
    return strictLocalize({
      id: "JvfdpN",
      defaultMessage: [{
        "type": 0,
        "value": "Como obter a oferta"
      }]
    });
  } else {
    return strictLocalize({
      id: "w7CyhN",
      defaultMessage: [{
        "type": 0,
        "value": "Como funciona a oferta de inscrição"
      }]
    });
  }
};
var HOW_DOES_SIGNUP_OFFER_WORK_DESCRIPTION = function HOW_DOES_SIGNUP_OFFER_WORK_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "x52u0e",
    defaultMessage: [{
      "type": 0,
      "value": "Quando adere à Faire utilizando o link de uma marca, recebe uma oferta de inscrição, incluindo uma promoção e um ano de envio gratuito nessa marca. A oferta é aplicada automaticamente no check-out e expira 7 dias após o registo."
    }]
  });
};